var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWizardStepCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9943 24C18.5861 24 24 18.5975 24 12.0057C24 5.41387 18.5861 0 11.9943 0C5.40255 0 0 5.41387 0 12.0057C0 18.5975 5.41387 24 11.9943 24ZM10.4769 18.1329C9.96718 18.1329 9.54812 17.8837 9.20834 17.4873L5.95775 13.6251C5.68592 13.3193 5.58398 13.0135 5.58398 12.6737C5.58398 11.9488 6.17294 11.3825 6.87516 11.3825C7.29423 11.3825 7.62268 11.5638 7.92849 11.9035L10.4542 14.9616L15.2905 7.29381C15.6076 6.80679 15.9813 6.55762 16.4457 6.55762C17.1366 6.55762 17.7709 7.06729 17.7709 7.79216C17.7709 8.07531 17.6576 8.39245 17.4651 8.68692L11.7227 17.4307C11.4283 17.8724 10.9752 18.1329 10.4769 18.1329Z",
    fill: "#009900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizardStepCompleted);
export default __webpack_public_path__ + "static/media/wizardStepCompleted.508a55ae41f5780e4c754e925b7a7ba3.svg";
export { ForwardRef as ReactComponent };